@let current = state();
@let intent = proposal();
@if (actions.enabled()) {
    @if (intent && canSelect() && current?.phase !== 'ready') {
        <header class="pack-header border-b border-border">
            <h3
                qpxHeading
                variant="lg"
                class="m-0"
                [id]="`${actionId()}-title`"
            >
                Create a pack
            </h3>
            <p qpxBody="secondary" tone="muted" class="m-0 mt-1">
                Keep the documents you need together.
            </p>
        </header>
    }
    @if (intent && canSelect() && current?.phase !== 'ready') {
        <fieldset
            class="m-0 grid min-w-0 gap-4 border-0 p-4 sm:p-5"
            [disabled]="busy()"
            [attr.aria-busy]="busy()"
        >
            <legend class="sr-only">
                Choose pack documents and requirements
            </legend>
            <qpx-quippy-pack-destination
                [actionId]="actionId()"
                [busy]="busy()"
                [(name)]="draft.name"
                [(description)]="draft.description"
                (changed)="invalidate()"
            />
            <qpx-quippy-pack-editor
                [smallHeaders]="appearance() === 'outlined'"
                [actionId]="actionId()"
                [disabled]="busy()"
                (changed)="invalidate()"
            />
            @if (error()) {
                <p
                    role="alert"
                    class="m-0 rounded-lg border border-destructive-muted bg-destructive-muted p-3 text-body-md text-destructive-muted"
                >
                    {{ error() }}
                </p>
            }
            <footer class="flex justify-end gap-1">
                <button
                    qpxButton
                    matButton="filled"
                    context="primary"
                    size="sm"
                    [disabled]="busy() || !draft.requirementOptions().length"
                    (click)="preview()"
                >
                    <ng-icon
                        qpx
                        size="sm"
                        name="lucideArrowRight"
                        matButtonIcon
                    /><span>Review change</span>
                </button>
            </footer>
        </fieldset>
    }
    <qpx-quippy-pack-result
        [state]="current"
        [actionId]="actionId()"
        (editClicked)="editDetails()"
        (applyClicked)="actions.apply(actionId())"
    />
    @if (error() && (!canSelect() || current?.phase === 'ready')) {
        <p
            role="alert"
            class="m-4 rounded-lg border border-destructive-muted bg-destructive-muted p-3 text-body-md text-destructive-muted"
        >
            {{ error() }}
        </p>
    }
}
